<template>
  <div class="text-center">
    <v-dialog v-model="dialog" max-width="1180" persistent>
      <v-card>
        <v-card-title class="text-h5 orange darken-3 white--text">
          Datos academicos Sistema Avatar
        </v-card-title>

        <v-card-text class="ma-0 pa-0">

            <div style="width:100%; height:min(700px, 100vh);">
                <iframe
                    src="https://avatar-upi.sladia.site/"
                    style="
                    width:100%;
                    height:100%;
                    border:none;
                    display:block;
                    "
                    loading="lazy"
                    allowfullscreen
                ></iframe>
            </div>

        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red" outlined @click="cerrar()"> Cerrar </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
  
<script>

export default {
    data() { 
        return { 
            dialog: false, 
        };
    }, 
    methods: {
        async openmodal() {  
          this.dialog = true;  
        },  
        cerrar(){
          if (this.resolvePromise) this.resolvePromise(false);
          this.dialog = false;
        }, 
    }
};
</script>

  
